import { formatNumber, formatTime } from '@/lib/formatter'
import { useReadBettingRecordHistoryQuery } from '@/redux/competition-betting'

export interface BettingHistoryProps {
  id: number
  competitorId: number
}

export default function BettingHistory({ id, competitorId }: BettingHistoryProps) {
    const { data: bettingRecordHistoryData } = useReadBettingRecordHistoryQuery({ competitionId: id, competitorId })

    const betMessage = (action: number, index: number) => {
        if (index === 1) {
            if (action === 1) {
                return 'Initial Subscription:'
            } else if (action === 2) {
                return 'Redeem #' + index + ':'
            }
        } else {
            if (action === 1) {
                return 'Re-subscribe #' + index + ':'
            } else if (action === 2) {
                return 'Redeem #' + index + ':'
            }
        }
        return ''
    }

    return (
        <div className="flex flex-col gap-2">
            {
                bettingRecordHistoryData?.rows.map((item, i) => (
                    <div className="flex justify-between items-center gap-2" key={i}>
                        <div className="text-xs text-secondary-foreground">
                            <span>{betMessage(item.action, item.index)}</span>
                            <span>{formatNumber()(item.amount)} pts</span>
                        </div>
                        <div className="text-xs text-muted-foreground">
                            {formatTime('MM/DD HH:mm:ss')(item.createdAt)}
                        </div>
                    </div>
            ))}
        </div>
    )
}